/**
 * Tekst veilig in losse HTML zetten: documenten (factuur, pakbon, bon), mails en nieuwsbrieven.
 * Dekt tekst tussen tags en waarden tussen dubbele of enkele aanhalingstekens. Niet voor
 * onaangehaalde attributen, `<script>` of `style` (daar komt in deze app geen invoer).
 * Eén definitie; utils/invoice.ts en admin/newsletter/newsletterHtml.ts geven hem door.
 */
const entities: Record<string, string> = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }

export const escapeHtml = (s: string) => s.replace(/[&<>"']/g, (c) => entities[c] ?? c)
